import { lazy } from 'react';

import { RouteItemType } from 'routes';
const Page = lazy(() => import('components/common/Page'));
const Monitor = lazy(() => import('app/monitor'));

export const monitorRoutes: Array<RouteItemType> = [
    {
        path: ['/monitor'],
        name: 'monitor.name',
        component: Monitor,
        props: {
            pageTitle: { value: 'monitor.title' },
        },
    },
];
